import { Injectable } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { Planner } from '@authority-labs/api-interfaces';
import { CrudDialog } from '@check-list/app/classes/crud-dialog';
import { CreatePlannerDialogComponent } from './create-planner-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class PlannerDialogService implements CrudDialog<Planner> {
  private dialogConfig: MatDialogConfig;

  constructor(private dialog: MatDialog) {
    this.dialogConfig = new MatDialogConfig();
  }

  create(): MatDialogRef<CreatePlannerDialogComponent, Planner> {
    this.dialogConfig.data = new Planner();
    return this.dialog.open(CreatePlannerDialogComponent, this.dialogConfig);
  }

  edit(planner: Planner): MatDialogRef<CreatePlannerDialogComponent, Planner> {
    this.dialogConfig.data = planner;
    return this.dialog.open(CreatePlannerDialogComponent, this.dialogConfig);
  }

  partialEdit(
    planner: Planner
  ): MatDialogRef<CreatePlannerDialogComponent, Planner> {
    this.dialogConfig.data.entity = planner;
    this.dialogConfig.data.strictMode = true;
    return this.dialog.open(CreatePlannerDialogComponent, this.dialogConfig);
  }
}
